export default {
  brand: 'CrypPay',
  transferHint: '请向以下地址转账',
  rechargeAmount: '充值金额',
  rechargeAddress: '充值地址',
  scanTip: '使用钱包扫码完成转账',
  copy: '复制',
  copied: '已复制',
  copyFail: '复制失败',
  networkFee: '网络手续费',
  eta: '预计到账时间',
  etaVal: '5-15 分钟',
  actualArrival: '实际到账',
  noticeTitle: '充值须知',
  notice1: '请仅向当前页面展示的二维码或地址转账，转错地址资产无法找回。',
  notice2: '转账金额必须精准为 {amount} {coin}，金额不符无法自动入账。',
  notice3: '请等待区块链节点确认（通常 1 次确认后自动到账）。',
  notice4: '链上转账不可撤销，因用户操作失误造成的损失由用户自行承担。',
  selectLang: '选择语言',
  back: '返回',
  pending: '待支付',
  paid: '已支付',
  timeout: '已超时',
  orderNo: '订单',
  loading: '加载中…',
  paramError: '链接参数不完整',
  initFail: '创建订单失败',
  paidSuccess: '支付成功',
  timedOut: '订单已超时，请重新发起'
}
